import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
    stage: 'sandbox',
    buildVersion: '56b141f7f1e7b8a5fe9c87e26bd885cecae1e87c',
    origins: {
        feedsFearsomeProcessor: 'https://sandbox-api.bannerflow.com/feeds-fearsome-processor',
        feedsSupremeCommander: 'https://sandbox-api.bannerflow.com/feeds-supreme-commander',
        feedsSocializingMaster: 'https://sandbox-api.bannerflow.com/feeds-socializing-master',
        acg: 'https://sandbox-api.bannerflow.com/acg',
        feedsDeliveryMaster: 'https://sandbox-api.bannerflow.com/feeds-delivery-master',
        listService: 'https://sandbox-api.bannerflow.com/list-service',
        sapi: 'https://sandbox-api.bannerflow.com/studio/api',
        designApi: 'https://sandbox-api.bannerflow.com/design-api/api',
        accountAccessService: 'https://sandbox-api.bannerflow.com/account-access',
        socialAccountService: 'https://sandbox-api.bannerflow.com/sas',
        bfc: 'https://sandbox-home.bannerflow.com',
        creativePreviewUrl: 'https://sandbox-api.bannerflow.com/preview',
        studio: 'https://sandbox-studio.bannerflow.com',
        notificationServiceApi: 'https://sandbox-api.bannerflow.com/notification-service/api',
        notificationServiceHub: 'https://sandbox-api.bannerflow.com/notification-service/hub',
        featureFlagService: 'https://api.bannerflow.com/features/api/frontend'
    },
    auth: {
        clientId: 'pD2aOQUrR5iPSLua1T9PqWIRvsHZbVgb',
        domain: 'https://sandbox-login.bannerflow.com',
        audience: 'https://bannerflow.com/resources/'
    },
    featureFlags: {
        clientKey: '*:development.ba00ae0e5481272a9f10258d046a3fd7ad063b806ae95abc428a1e68'
    },
    intercom: {
        appId: 'vc7jxmzv'
    },
    gtm: {
        id: 'GTM-M2FZ5ZZ'
    }
};
